// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___WSUxM","prev":"styles__prev___ovB3n","next":"styles__next___UwP2E"};